// @flow

import { makeActionCreator } from './index';

export const ADD_CONTACT = 'ADD_CONTACT';
export const REMOVE_CONTACT = 'REMOVE_CONTACT';

export const addContact = makeActionCreator(ADD_CONTACT, 'payload');
export const removeContact = makeActionCreator(REMOVE_CONTACT, 'payload');
